module.exports = __webpack_public_path__ + "img/world_voting.c84de766.jpg";